import {
  ListItemButton as MuiListItemButton,
  ListItemText as MuiListItemText,
  styled,
} from "@mui/material";
import clsx from "clsx";

const MuiListItemButtonStyled = styled(MuiListItemButton)({
  width: "100%",
  padding: "0.375rem 0.5rem",
  borderBottom: "1px solid #E1E1E1",
  cursor: "pointer",
  ":hover": {
    backgroundColor: "#f7f7fc",
  },
  display: "flex",
  gap: "0.5rem",
  overflowX: "hidden",
  "& .check-input": {
    flexShrink: 0,
    cursor: "pointer",
  },
});

const MuiListItemTextStyled = styled(MuiListItemText)({
  margin: 0,
  "& .text-row": {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
});

const PrimaryTextStyled = styled("span")({
  fontSize: "14px",
  fontWeight: 500,
  color: "#184C7B",
});
const SecondaryTextStyled = styled("span")({
  fontWeight: 300,
  fontSize: "14px",
  color: "#6969A4",
});
const HelperTextStyled = styled("span")({
  flexShrink: 0,
  maxWidth: "40%",
  fontWeight: 300,
  fontSize: "12px",
  color: "#6969A4",
});
const BottomHelperTextStyled = styled("span")({
  fontWeight: 400,
  fontSize: "12px",
  color: "#184C7B",
});

const ListItemUnstyled = ({
  primaryText,
  secondaryText,
  bottomHelperText,
  isDisabled,
  isSelected,
  topHelperText,
  midHelperText,
  classNames = {},
  className,
  onClick,
  onCheck,
}) => {
  return (
    <MuiListItemButtonStyled
      onClick={onClick}
      disabled={isDisabled}
      className={className}
      sx={{
        backgroundColor: isSelected ? "#EBEBEB" : "#ffffff",
      }}
    >
      {onCheck && (
        <input
          type="checkbox"
          onClick={(e) => e.stopPropagation()}
          onChange={onCheck}
          className="check-input"
        />
      )}
      <div style={{ width: onCheck ? "calc(100% - 15px)" : "100%" }}>
        <MuiListItemTextStyled
          slotProps={{
            primaryTypography: { className: "text-truncate" },
            secondaryTypography: { className: "text-truncate" },
          }}
          primary={
            topHelperText ? (
              <span className="top-row">
                <PrimaryTextStyled
                  className={clsx(
                    "primary-text text-truncate",
                    classNames.primary
                  )}
                >
                  {primaryText}
                </PrimaryTextStyled>
                <HelperTextStyled
                  className={clsx(
                    "helper-text text-truncate",
                    classNames.helper
                  )}
                >
                  {topHelperText}
                </HelperTextStyled>
              </span>
            ) : (
              <PrimaryTextStyled
                className={clsx(
                  "primary-text text-truncate",
                  classNames.primary
                )}
              >
                {primaryText}
              </PrimaryTextStyled>
            )
          }
          secondary={
            midHelperText ? (
              <span className="text-row text-truncate">
                <SecondaryTextStyled
                  className={clsx(
                    "secondary-text text-truncate",
                    classNames.secondary
                  )}
                >
                  {secondaryText}
                </SecondaryTextStyled>
                <HelperTextStyled
                  className={clsx(
                    "helper-text text-truncate",
                    classNames.helper
                  )}
                >
                  {midHelperText}
                </HelperTextStyled>
              </span>
            ) : (
              <SecondaryTextStyled
                className={clsx(
                  "secondary-text text-truncate",
                  classNames.secondary
                )}
              >
                {secondaryText}
              </SecondaryTextStyled>
            )
          }
        />
        <MuiListItemTextStyled
          primary={
            <BottomHelperTextStyled
              className={clsx(
                "bottom-helper-text text-truncate",
                classNames.bottom
              )}
            >
              {bottomHelperText}
            </BottomHelperTextStyled>
          }
        />
      </div>
    </MuiListItemButtonStyled>
  );
};

const ListItem = styled(ListItemUnstyled)({});

export default ListItem;
